import { Component } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IHMSStudentResponse } from '../../interfaces/ihms-dashboard-response';
import { IhmsGridStatus } from '../../enums/ihms-grid-status';
import { IIhmsSavePayload } from '../../interfaces/ihms-save-payload';
import { ApiResponse } from '../../interfaces/api-response';
import { IhmsService } from '../../services/ihms.service';
import {
  IhmsNotificationMessageKeys,
  IhmsNotificationMessages,
  NOTIFICATION_MESSAGES,
} from '../../constants/notification-messages';
import { NotificationService } from '@progress/kendo-angular-notification';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IhmsActionItems } from '../../enums/ihms-action-items';

@Component({
  selector: 'app-send-back-ihms',
  templateUrl: './send-back-ihms.component.html',
  styleUrls: ['./send-back-ihms.component.scss'],
  standalone: false,
})
export class SendBackIhmsComponent extends DialogContentBase {
  actionDetails: IHMSStudentResponse;
  loadSpinner: boolean = false;
  studentId: string;
  studentName: string;
  form: FormGroup;

  constructor(
    dialogRef: DialogRef,
    private ihmsService: IhmsService,
    private notificationService: NotificationService
  ) {
    super(dialogRef);
    this.form = new FormGroup({
      explanation: new FormControl('', [
        Validators.required,
        Validators.maxLength(500),
      ]),
    });
  }

  getStatus(status: number): string {
    if (status === IhmsGridStatus.Assigned) {
      return 'Assigned';
    } else if (status === IhmsGridStatus.New) {
      return ' New';
    } else if (status === IhmsGridStatus.Returned) {
      return ' Returned';
    } else if (status === IhmsGridStatus.Completed) {
      return 'Completed';
    } else if (status === IhmsGridStatus.SubmittedForReview) {
      return 'Submitted For Review';
    }
    return '';
  }

  sendBack(): void {
    this.loadSpinner = true;

    // Construct the payload for sending back the IHMS action item
    const payload: IIhmsSavePayload = {
      ihmsid: this.actionDetails.id,
      ihmscaseNo: this.actionDetails.ihmsCaseNo,
      performedBy: 'testing test', // populate with logged in user
      actionItemId: this.actionDetails?.action_Item_Id,
      explanation: this.form?.get('explanation')?.value,
      assigne: this.actionDetails.assigne,
      uiAction: IhmsActionItems.SendBack,
    };

    this.ihmsService.saveIhmsData(payload).subscribe({
      next: (res: ApiResponse<IHMSStudentResponse>) => {
        if (res.isRequestSucessful) {
          const message: string = IhmsNotificationMessages[
            IhmsNotificationMessageKeys.SentBackSuccess
          ](this.actionDetails.name);
          this.notificationService.show({
            content: message,
            cssClass: 'notification-message-class-ihms',
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'slide', duration: 60 },
            type: { style: 'success', icon: true },
            closable: false,
          });
        }
        this.ihmsService.getReloadIhmsGridDetails(true);
        this.dialog.close();
        this.loadSpinner = false;
      },
      error: () => {
        this.loadSpinner = false;
        this.notificationService.show({
          content: NOTIFICATION_MESSAGES.submissionFailed,
          position: { horizontal: 'center', vertical: 'top' },
          animation: { type: 'slide', duration: 60 },
          type: { style: 'error', icon: true },
          closable: true,
        });
      },
    });
  }
}
